module.exports = __webpack_public_path__ + "static/seuatleta-49fe9824fb67bb23864cd33dfd386d51.png";